export const formatNumber = (value: number, minimumFractionDigits: number = 2): string =>
  value.toLocaleString(navigator.language, { minimumFractionDigits });

export const convertToCurrency = (value: number): string => `£ ${formatNumber(value)}`;
